// Ce fichier est généré automatiquement par scripts/generate-service-registers.js
// Ne pas modifier manuellement - vos changements seront écrasés
// Pour régénérer : pnpm run generate:service-registers

// ================================
// IMPORTS DES SERVICES
// ================================
import { PvService } from "./pv.service"

// ================================
// EXPORTS DES SERVICES
// ================================
export * from "./pv.service"

// ================================
// REGISTRY DES SERVICES
// ================================
export const pvServiceRegistry = {
    pv: new PvService(),
} as const

// ================================
// TYPES DU REGISTRY
// ================================
export type PvServiceRegistry = typeof pvServiceRegistry
